import { restClient } from '../client';

export type ProviderEngagementOutput = {
  hasIdealCaseload: boolean;
  hasAtLeastFiveSpecialties: boolean;
  hasEnoughHours: boolean;
};

export const providerEngagementRequest = restClient.createRequest<null, ProviderEngagementOutput>({
  url: '/api/v1/provider/engagement',
  method: 'GET',
});
